/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S16_HeadingInputs */

const tr_mesafeli_s16_heading = /** @type {(inputs: Mesafeli_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Kişisel Verilerin Korunması`)
};

const en_mesafeli_s16_heading = /** @type {(inputs: Mesafeli_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Protection of Personal Data`)
};

const de_mesafeli_s16_heading = /** @type {(inputs: Mesafeli_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Schutz personenbezogener Daten`)
};

const ru_mesafeli_s16_heading = /** @type {(inputs: Mesafeli_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Защита персональных данных`)
};

/**
* | output |
* | --- |
* | "16. Protection of Personal Data" |
*
* @param {Mesafeli_S16_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s16_heading = /** @type {((inputs?: Mesafeli_S16_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S16_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s16_heading(inputs)
	if (locale === "de") return de_mesafeli_s16_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s16_heading(inputs)
	return tr_mesafeli_s16_heading(inputs)
});